import React from "react";
import { Phone, Send } from "lucide-react";
import { SITE_CONFIG, telHref, telegramLink } from "../lib/config";
import { trackCall, trackEvent } from "../lib/analytics";

export default function FinalCTA({ lang, T, scrollTo }) {
  return (
    <section id="final" className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img src="/images/aircooler/1.png" alt="" loading="lazy" className="w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink-900 via-ink-900/80 to-ink-900/40" />
        <div className="airflow-bg" />
      </div>

      <div className="relative mx-auto max-w-5xl px-4 md:px-6 text-center">
        <span className="chip mx-auto mb-5">{SITE_CONFIG.deadline[lang]}</span>
        <h2 className="font-display font-bold text-4xl md:text-6xl tracking-tight leading-[1.05]">
          {T.finalCta.h2[lang]}
        </h2>
        <p className="mt-5 text-muted text-base md:text-lg max-w-2xl mx-auto">{T.finalCta.sub[lang]}</p>
        <p className="mt-3 text-danger text-sm font-semibold">{T.finalCta.urgency[lang]}</p>

        <div className="mt-9 flex flex-col sm:flex-row gap-3 justify-center items-stretch sm:items-center">
          <a
            href={telHref}
            onClick={() => trackCall("final")}
            data-testid="final-call-button"
            className="cta-pulse inline-flex items-center justify-center gap-3 btn-call rounded-full px-8 py-5 text-xl shadow-flame"
          >
            <Phone size={22} strokeWidth={2.6} /> {T.cta.callNow[lang]}
          </a>
          <a
            href={telegramLink}
            target="_blank" rel="noreferrer"
            onClick={() => trackEvent("ClickTelegram", { source: "final", language: lang })}
            data-testid="final-telegram-button"
            className="inline-flex items-center justify-center gap-3 rounded-full px-8 py-5 text-xl font-bold transition hover:brightness-110 shadow-lg"
            style={{ background: "#229ED9", color: "white" }}
          >
            <Send size={20} /> {T.cta.writeTelegram[lang]}
          </a>
        </div>
      </div>
    </section>
  );
}
